import React from "react";
import { AlertOctagon, DollarSign, Wrench } from "lucide-react";
import { hours } from "@/lib/faultFormat";

export function FaultsKpiStrip({ totals, loading }) {
  const cards = [
    { label: "Active faults", value: loading ? "…" : totals.count, testId: "faults-kpi-count", Icon: Wrench, color: "#156F5B" },
    { label: "Critical", value: loading ? "…" : totals.critical, testId: "faults-kpi-critical", Icon: AlertOctagon, color: "#B91C1C" },
    { label: "Total duration", value: loading ? "…" : hours(totals.hours), testId: "faults-kpi-hours", Icon: Wrench, color: "#0E7490" },
    {
      label: "Estimated impact",
      value: loading ? "…" : `$${totals.cost.toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
      testId: "faults-kpi-cost",
      Icon: DollarSign,
      color: "#C2410C",
    },
  ];

  return (
    <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((k) => (
        <div key={k.label} className="k-card p-5" data-testid={k.testId}>
          <div className="k-label flex items-center gap-2">
            <k.Icon className="h-3.5 w-3.5" style={{ color: k.color }} /> {k.label}
          </div>
          <div className="mt-2 text-2xl font-heading font-semibold text-[#212121]">{k.value}</div>
        </div>
      ))}
    </div>
  );
}
